/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAutotaskCompanies200ResponseCompaniesInner } from './GetAutotaskCompanies200ResponseCompaniesInner';
import {
    GetAutotaskCompanies200ResponseCompaniesInnerFromJSON,
    GetAutotaskCompanies200ResponseCompaniesInnerFromJSONTyped,
    GetAutotaskCompanies200ResponseCompaniesInnerToJSON,
    GetAutotaskCompanies200ResponseCompaniesInnerToJSONTyped,
} from './GetAutotaskCompanies200ResponseCompaniesInner';

/**
 * 
 * @export
 * @interface GetNinjaOneOrganizations200Response
 */
export interface GetNinjaOneOrganizations200Response {
    /**
     * 
     */
    organizations: Array<GetAutotaskCompanies200ResponseCompaniesInner>;
}

/**
 * Check if a given object implements the GetNinjaOneOrganizations200Response interface.
 */
export function instanceOfGetNinjaOneOrganizations200Response(value: object): value is GetNinjaOneOrganizations200Response {
    if (!('organizations' in value) || value['organizations'] === undefined) return false;
    return true;
}

export function GetNinjaOneOrganizations200ResponseFromJSON(json: any): GetNinjaOneOrganizations200Response {
    return GetNinjaOneOrganizations200ResponseFromJSONTyped(json, false);
}

export function GetNinjaOneOrganizations200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNinjaOneOrganizations200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'organizations': ((json['organizations'] as Array<any>).map(GetAutotaskCompanies200ResponseCompaniesInnerFromJSON)),
    };
}

export function GetNinjaOneOrganizations200ResponseToJSON(json: any): GetNinjaOneOrganizations200Response {
    return GetNinjaOneOrganizations200ResponseToJSONTyped(json, false);
}

export function GetNinjaOneOrganizations200ResponseToJSONTyped(value?: GetNinjaOneOrganizations200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizations': ((value['organizations'] as Array<any>).map(GetAutotaskCompanies200ResponseCompaniesInnerToJSON)),
    };
}

